export type RecorderInterruptReason = 'track-ended' | 'recorder-error';
/**
 * - `success` — auto-resume re-acquired the mic on attempt N.
 * - `failure` — a single auto-resume attempt failed (transient). Emitted
 *   for every individual failure; the retry budget may still have headroom.
 * - `budget-exhausted` — the retry budget is spent and auto-resume will
 *   not run again until the user manually retries. Terminal.
 * - `permission-denied` — the user revoked mic access. Terminal; no retry.
 */
export type RecoveryOutcome = 'budget-exhausted' | 'failure' | 'permission-denied' | 'success';

interface InterruptionRecoveryPayload {
  attempt: number;
  event: 'audio.interruption.recovery';
  outcome: RecoveryOutcome;
  ts: number;
}

interface InterruptionStartPayload {
  attempt?: never;
  event: 'audio.interruption.start';
  reason: RecorderInterruptReason;
  ts: number;
}

export function recordInterruptionRecovery(outcome: RecoveryOutcome, attempt: number): void {
  emit({ outcome, attempt, ts: Date.now(), event: 'audio.interruption.recovery' });
}

export function recordInterruptionStart(reason: RecorderInterruptReason): void {
  emit({ reason, ts: Date.now(), event: 'audio.interruption.start' });
}

// One TODO: when telemetry sink (Sentry / PostHog) is added, swap console.info
// for the sink. Keep the JSON shape stable so existing log-scrape rules survive.
function emit(payload: InterruptionRecoveryPayload | InterruptionStartPayload): void {
  console.info(JSON.stringify(payload));
}
